import { useState, useEffect, useRef } from 'react';
import { Search, Server, AlertTriangle, RefreshCw, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, ChevronDown, ChevronUp, TableOfContents, CalendarDays, Columns3, Monitor, Download, Check, Copy, X, CircleEllipsis, Loader2, User, Settings, Tag, Eye, EyeOff } from 'lucide-react';

import { Modal } from "@mui/material";
// import { jwt_decode } from '../utlis/jwt_decode';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ScrollContainer from 'react-indiana-drag-scroll';
import { createPortal } from "react-dom";
import AgentConfigModal from './AgentConfigModal';

import { showError, showSuccess } from '../../utils/toast';
import baseapi from '../../services/baseapi';
import { ItemsPerPageDropdown } from '../../components/ItemsPerPageDropdown ';
import { useClientLevel } from '../../hooks/useClientLevel';
import { hasPermission } from '../../utils/permissionsHelper';
import AgentExportModal from '../Agent/AgentExportModal';
import KubernetesClustersTable, { type ClusterColumnKey, defaultClusterVisibleColumns, clusterColumnOptions } from './KubernetesClustersTable';
import SingleSelectApiDropdown from '../../components/SingleSelectApiDropdown';
import AgentTagModal from './AgentTagModal';


// interface SubnetModalProps {
//     agent?: any
//     open: boolean;
//     onClose: () => void;
// }

// interface SubnetData {
//     name: string;
//     subnet: string;
//     description: string;
//     enabled: boolean;
//     priority: number;
//     excludeIPs: string[];
//     ports: number[];
// }

type ColumnKey =
    | 'hostname'
    | 'status'
    | 'version'
    | 'auto_update_enabled'
    | 'tags'
    | 'created'
    | 'client_name'
    | 'actions';

// const NameDisplay: React.FC<{ name: string; maxLength?: number }> = ({
//     name,
//     maxLength = 20
// }) => {
//     const [isExpanded, setIsExpanded] = useState(false);

//     const shouldTruncate = name.length > maxLength;
//     const displayName = shouldTruncate && !isExpanded
//         ? `${name.substring(0, maxLength)}...`
//         : name;

//     return (
//         <div className="flex items-center gap-2">
//             <span className="text-white font-medium">
//                 {displayName}
//             </span>
//             {shouldTruncate && (
//                 <button
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setIsExpanded(!isExpanded);
//                     }}
//                     className="text-blue-400 hover:text-blue-300 text-sm underline"
//                 >
//                     {isExpanded ? <><CircleMinus className='w-5 h-5 text-gray-100' /> </> : <><CirclePlus className='w-5 h-5 text-gray-100' /> </>}
//                 </button>
//             )}
//         </div>
//     );
// };




const KubernetesTable = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') || 'clusters';
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [showColumnSettings, setShowColumnSettings] = useState(false);
    const [agentData, setAgentData] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [clusterRefreshTrigger, setClusterRefreshTrigger] = useState(0);
    const [clustersLoading, setClustersLoading] = useState(false);
    // const decodedToken = jwt_decode();

    const storedLevel = localStorage.getItem('level');
    const level = storedLevel ? JSON.parse(storedLevel) : null;
    const navigate = useNavigate();
    const [showInstallModal, setShowInstallModal] = useState(false);

    // New states for K8s install YAML generation
    const [clusterName, setClusterName] = useState("");
    const [clusterTags, setClusterTags] = useState<string[]>([]);
    const [currentTagInput, setCurrentTagInput] = useState("");
    const [generatedYaml, setGeneratedYaml] = useState("");
    const [clusterId, setClusterId] = useState<any>(null);
    const [isGeneratingYaml, setIsGeneratingYaml] = useState(false);
    const [yamlCopied, setYamlCopied] = useState(false);

    // Existing agent options states
    const [installMethod, setInstallMethod] = useState<'manual' | 'existing'>('manual');
    const [selectedExistingAgent, setSelectedExistingAgent] = useState<any>(null);
    const [isK8sEnabled, setIsK8sEnabled] = useState(false);
    const [isEnablingK8s, setIsEnablingK8s] = useState(false);
    const [kubeconfigPath, setKubeconfigPath] = useState("");

    //pagination states and vars
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState<number>(30);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;


    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const menuDropdownRef = useRef<HTMLDivElement | null>(null);
    const [showExportModal, setShowExportModal] = useState(false);
    const [showConfigModal, setShowConfigModal] = useState(false);
    const [selectedAgentForConfig, setSelectedAgentForConfig] = useState<any>(null);
    const [tagModalOpen, setTagModalOpen] = useState(false);
    const [tagAgentId, setTagAgentId] = useState<number | null>(null);
    const [tagAgentName, setTagAgentName] = useState<string>('');
    const [tagAgentTags, setTagAgentTags] = useState<string[]>([]);
    const canCreate = hasPermission('agents', 'create');
    const canDelete = hasPermission('agents', 'delete');
    const canEdit = hasPermission('agents', 'update');

    const handleCloseInstallModal = () => {
        setShowInstallModal(false);
        setClusterName("");
        setClusterTags([]);
        setCurrentTagInput("");
        setGeneratedYaml("");
        setClusterId(null);
        setIsGeneratingYaml(false);
        setYamlCopied(false);
        setInstallMethod("manual");
        setSelectedExistingAgent(null);
        setIsK8sEnabled(false);
        setKubeconfigPath("");
    };

    const handleSelectExistingAgent = (item: any) => {
        setSelectedExistingAgent(item);
        if (item) {
            const enabled = item.k8s_enabled === true || item.k8_enabled === true;
            setIsK8sEnabled(enabled);
        } else {
            setIsK8sEnabled(false);
        }
    };

    const handleEnableK8s = async () => {
        if (!selectedExistingAgent) return;
        setIsEnablingK8s(true);
        try {
            const res = await baseapi.put(`/agents/${selectedExistingAgent.id}`, {
                k8_enabled: true
            }, {
                params: { k8_enabled: true }
            });
            if (res.data?.status || res.status === 200) {
                showSuccess("Kubernetes enabled successfully on the agent!");
                setIsK8sEnabled(true);
                setSelectedExistingAgent((prev: any) => prev ? { ...prev, k8s_enabled: true, k8_enabled: true } : null);
            } else {
                showError(res.data?.message || "Failed to enable Kubernetes.");
            }
        } catch (error: any) {
            console.error("Error enabling Kubernetes on agent:", error);
            showError(error.message || "Failed to enable Kubernetes.");
        } finally {
            setIsEnablingK8s(false);
        }
    };

    const handleAddKubeconfigPath = () => {
        if (!kubeconfigPath.trim()) {
            showError("Please enter a path.");
            return;
        }
        console.log("Adding path:", kubeconfigPath, "for agent:", selectedExistingAgent?.id);
        showSuccess(`Path added successfully: ${kubeconfigPath}`);
        setKubeconfigPath("");
    };

    const handleGenerateYaml = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!clusterName.trim()) {
            showError("Please enter a cluster name.");
            return;
        }
        setIsGeneratingYaml(true);
        try {
            // 1. Create the cluster
            const createResponse = await baseapi.post('k8s_clusters/', {
                name: clusterName.trim(),
                client_id: level?.id,
                tags: clusterTags
            });

            // Handle possible response structures to extract cluster_id
            const clusterIdVal = createResponse.data?.cluster_id || createResponse.data?.data?.cluster_id || createResponse.data?.id || createResponse.data?.data?.id;

            if (!clusterIdVal) {
                throw new Error("Failed to get cluster ID from response.");
            }
            setClusterId(clusterIdVal);

            // 2. Fetch the YAML (without download parameter)
            const yamlResponse = await baseapi.get(`k8s_clusters/${clusterIdVal}/yaml`);

            const yamlData = yamlResponse.data?.data?.yaml || yamlResponse.data?.yaml;
            if (yamlData !== undefined) {
                setGeneratedYaml(yamlData);
                showSuccess("YAML configuration generated successfully!");
            } else {
                throw new Error("YAML data not found in response.");
            }
        } catch (error: any) {
            console.error("Error generating YAML config:", error);
            const errMsg = error.response?.data?.message || error.message || "Failed to generate YAML configuration.";
            showError(errMsg);
        } finally {
            setIsGeneratingYaml(false);
        }
    };

    const copyYamlToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(generatedYaml);
            setYamlCopied(true);
            showSuccess("YAML config copied to clipboard!");
            setTimeout(() => setYamlCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
            showError("Failed to copy text.");
        }
    };

    const downloadYamlFile = async () => {
        try {
            if (!clusterId) {
                showError("No cluster ID found to download.");
                return;
            }
            // Fetch YAML with download parameter set to 'true'
            const yamlResponse = await baseapi.get(`k8s_clusters/${clusterId}/yaml`, {
                params: { download: 'true' }
            });

            const yamlData = yamlResponse.data?.data?.yaml || yamlResponse.data?.yaml || yamlResponse.data;
            const finalYaml = (typeof yamlData === 'string') ? yamlData : (yamlData?.yaml || generatedYaml);

            const blob = new Blob([finalYaml], { type: 'text/yaml' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${clusterName.replace(/\s+/g, '_') || 'k8s'}-cluster.yaml`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            showSuccess("YAML download started.");
        } catch (err: any) {
            console.error('Failed to download: ', err);
            showError("Failed to download file.");
        }
    };


    //sorting
    const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' } | null>(null);
    const isSortable = (key: string) => !['actions', 'tags'].includes(key);
    // const [showCredsModal, setShowCredsModal] = useState(false);

    const currentLevel = useClientLevel();
    const isFirstSearch = useRef(true);


    // Column visibility state
    const [columnVisibility, setColumnVisibility] = useState<Record<ColumnKey, boolean>>({
        hostname: true,
        status: true,
        version: true,
        auto_update_enabled: true,
        tags: true,
        created: true,
        actions: true,
        client_name: true,
    });

    const [clusterVisibleColumns, setClusterVisibleColumns] = useState<Record<ClusterColumnKey, boolean>>(defaultClusterVisibleColumns);
    const [showClusterColumnSettings, setShowClusterColumnSettings] = useState(false);

    const dropdownRef = useRef<HTMLDivElement>(null);

    //permissions


    const fetchData = async (
        skip: number = (currentPage - 1) * itemsPerPage || 0, limit: number = itemsPerPage || 30,
        orderBy: Record<string, 'asc' | 'desc'>[] = [{ name: 'desc' }]) => {
        try {
            setLoading(true)

            const [sortEntry] = orderBy;
            const sort_by = Object.keys(sortEntry)[0];
            const sort_order = sortEntry[sort_by];


            const queryObj: any = {
                ...(level?.id ? { client_id: level.id } : {}),
                $and: [
                    {
                        $or: [
                            { agent_type: "k8" },
                            { k8_enabled: true }
                        ]
                    }
                ]
            };

            if (debouncedSearch) {
                queryObj.$and.push({
                    $or: [
                        { hostname: { $ilike: `%${debouncedSearch}%` } },
                        { ip_address: { $ilike: `%${debouncedSearch}%` } },
                        { name: { $ilike: `%${debouncedSearch}%` } }
                    ]
                });
            }

            const params = {
                query: JSON.stringify(queryObj),

                skip: skip,
                limit: limit,
                sort_by: sort_by,
                sort_order: sort_order
            }

            try {
                const response = await baseapi.get('/agents', { params })
                // const response ={data:{status: false}}
                if (response.data.status) {
                    setAgentData(response.data.data)
                    setLoading(false)
                    setTotalPages(Math.ceil(response.data.total / limit))
                    setTotalItems(response.data.total)
                } else {
                    // Fallback to mock data
                    setAgentData([])
                    setTotalPages(0)
                    setTotalItems(0)
                    setLoading(false)
                }
            } catch (apiError) {
                console.warn('API call failed, using mock data:', apiError);
                // Use mock data as fallback
                setAgentData([])
                setTotalPages(0)
                setTotalItems(0)
                setLoading(false)
            }
        }
        catch (error: any) {
            showError(error.message)
            // Fallback to mock data
            setAgentData([])
            setTotalPages(0)
            setTotalItems(0)
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchData();
    }, [currentLevel]);

    // Debounce search term
    useEffect(() => {
        const handler = setTimeout(() => {
            if (debouncedSearch !== searchTerm) {
                setDebouncedSearch(searchTerm);
                setCurrentPage(1);
            }
        }, 500);
        return () => clearTimeout(handler);
    }, [searchTerm, debouncedSearch]);

    // Re-fetch when debouncedSearch changes
    useEffect(() => {
        if (isFirstSearch.current) {
            isFirstSearch.current = false;
            return;
        }
        fetchData(0, itemsPerPage);
    }, [debouncedSearch]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowColumnSettings(false);
                setShowClusterColumnSettings(false);
            }
            if (menuDropdownRef.current && !menuDropdownRef.current.contains(event.target as Node)) {
                setOpenMenuId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleRefresh = () => {
        setSearchTerm('');
        setDebouncedSearch('');
        setCurrentPage(1);
        fetchData();
    };

    // const filteredData = agentData.filter((item: any) =>
    //     item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     item.hostname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     item.ip_address?.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    const copyToClipboard = async (text: any, _fieldName: any) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };




    const getStatusColor = (status: string) => {
        switch (status) {
            case 'online': return 'text-green-400';
            case 'offline': return 'text-red-500';
            case 'busy': return 'text-yellow-400';
            case 'error': return 'text-red-400';
            case 'maintenance': return 'text-blue-400';
            default: return 'text-gray-100';
        }
    };

    const getStatusBg = (status: string) => {
        switch (status) {
            case 'online': return 'bg-green-400';
            case 'offline': return 'bg-red-500';
            case 'busy': return 'bg-yellow-400';
            case 'error': return 'bg-red-400';
            case 'maintenance': return 'bg-blue-400';
            default: return 'bg-gray-400';
        }
    };

    const toggleColumn = (key: ColumnKey) => {
        setColumnVisibility((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const toggleAllColumns = () => {
        const allVisible = Object.values(columnVisibility).every(Boolean);
        const newState = Object.keys(columnVisibility).reduce((acc, key) => {
            acc[key as ColumnKey] = !allVisible;
            return acc;
        }, {} as Record<ColumnKey, boolean>);
        setColumnVisibility(newState);
    };

    const handleClusterColumnToggle = (column: ClusterColumnKey) => {
        setClusterVisibleColumns(prev => ({
            ...prev,
            [column]: !prev[column]
        }));
    };

    const toggleAllClusterColumns = () => {
        const allVisible = Object.values(clusterVisibleColumns).every(Boolean);
        const newState = Object.keys(clusterVisibleColumns).reduce((acc, key) => {
            acc[key as ClusterColumnKey] = !allVisible;
            return acc;
        }, {} as Record<ClusterColumnKey, boolean>);
        setClusterVisibleColumns(newState);
    };

    const handleSort = (key: string) => {
        setSortConfig((prev) => {
            if (prev?.key === key) {
                const newDirection = prev.direction === 'asc' ? 'desc' : 'asc';
                fetchData((currentPage - 1) * itemsPerPage, itemsPerPage, [{ [key]: newDirection }]);
                return { key, direction: newDirection };
            } else {
                fetchData((currentPage - 1) * itemsPerPage, itemsPerPage, [{ [key]: 'asc' }]);
                return { key, direction: 'asc' };
            }
        });
    };

    //pagination functions
    const handlePageChange = (page: number): void => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            fetchData((itemsPerPage * (page - 1)), itemsPerPage)
        }
    };

    const handleItemsPerPageChange = (value: number): void => {
        setItemsPerPage(value);
        setCurrentPage(1);
        fetchData(0, value)
    };



    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>, id: string) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setDropdownPosition({
            top: rect.bottom + 1,
            left: rect.right - 160, // adjust for alignment
        });
        setOpenMenuId(openMenuId === id ? null : id);
    };





    // const handleDelete = async (agent_id: string) => {
    //     try {
    //         const response = await baseapi.delete(`/agents/${agent_id}`)
    //         if (response.data.status) {
    //             showSuccess(response.data.message)
    //             fetchData()
    //         }
    //         else {
    //             showError(response.data.message)
    //         }
    //     }
    //     catch (error: any) {
    //         showError(error.message)
    //     }
    // };

    // const handleAgentClick = (agentId: any, client_id: any) => {
    //     localStorage.setItem('ids', JSON.stringify({ 'agent_id': agentId, client_id: client_id, 'path': "/agents/results" }))
    //     navigate("/agents/dashboard")
    // }



    const baseColumns: {
        key: ColumnKey;
        label: string;
        icon: React.ElementType;
        color: string;
    }[] = [
            { key: 'hostname', label: 'Cluster Name', icon: Server, color: 'text-blue-400' },
            { key: 'status', label: 'Status', icon: AlertTriangle, color: 'text-yellow-400' },
            { key: 'version', label: 'Version', icon: Monitor, color: 'text-teal-400' },
            // { key: 'auto_update_enabled', label: 'Auto Update', icon: RefreshCw, color: 'text-green-400' },
            { key: 'tags', label: 'Tags', icon: Columns3, color: 'text-purple-400' },
            { key: 'client_name', label: 'Client Name', icon: User, color: 'text-gray-100' },
            { key: 'created', label: 'Created At', icon: CalendarDays, color: 'text-gray-100' },
            { key: 'actions', label: 'Action', icon: TableOfContents, color: 'text-gray-100' },
        ];

    const columns = baseColumns.filter((col) => {
        // hide actions if no permission
        if (col.key === "actions" && !(canDelete || canEdit)) return false;

        // hide client_name if not global level
        if (col.key === "client_name" && level.name !== "global") return false;

        return true;
    });

    return (
        <div className="text-gray-800 dark:text-gray-100 p-3 pb-20 min-h-screen transition-colors duration-200">
            <div className="w-full mx-auto">
                {/* Header */}
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-2">
                    <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1.5">
                            <div className="">
                                <img src="/kubernetes.svg" className="w-6 h-6 text-white" />
                            </div>
                            <div>
                                <h1 className="font-bold text-lg text-gray-900 dark:text-gray-200 leading-none transition-colors duration-200">Kubernetes</h1>
                            </div>
                        </div>

                        {/* Tabs: Agents & Clusters */}
                        <div className="flex bg-gray-100 dark:bg-gray-800/80 p-0.5 rounded-lg border border-gray-200 dark:border-gray-700/50 transition-colors duration-200">
                            <button
                                onClick={() => {
                                    setSearchParams(prev => {
                                        const nextParams = new URLSearchParams(prev);
                                        nextParams.set('tab', 'clusters');
                                        return nextParams;
                                    });
                                }}
                                className={`px-3 py-1 text-xs font-bold rounded-md transition-all ${activeTab === 'clusters'
                                    ? 'bg-orange-600 text-white shadow-md'
                                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                                    }`}
                            >
                                Clusters
                            </button>
                            <button
                                onClick={() => {
                                    setSearchParams(prev => {
                                        const nextParams = new URLSearchParams(prev);
                                        nextParams.set('tab', 'agents');
                                        return nextParams;
                                    });
                                }}
                                className={`px-3 py-1 text-xs font-bold rounded-md transition-all ${activeTab === 'agents'
                                    ? 'bg-orange-600 text-white shadow-md'
                                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                                    }`}
                            >
                                Agents
                            </button>

                        </div>
                    </div>

                    {/* Search and Controls */}
                    <div className="flex items-center gap-2">
                        {/* Refresh */}
                        <button
                            onClick={activeTab === 'agents' ? handleRefresh : () => setClusterRefreshTrigger(prev => prev + 1)}
                            disabled={activeTab === 'agents' ? loading : clustersLoading}
                            className="rounded-lg bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-100 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 shadow-sm"
                            title="Refresh"
                        >
                            <RefreshCw className={`w-3.5 h-3.5 ${(activeTab === 'agents' ? loading : clustersLoading) ? 'animate-spin' : ''}`} />
                        </button>

                        {/* Search Input (always show, filters both) */}
                        <div className="relative w-full sm:w-56">
                            <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-100 w-3.5 h-3.5 transition-colors duration-200" />
                            <input
                                type="text"
                                placeholder={activeTab === 'agents' ? "Search kubernetes..." : "Search clusters..."}
                                className="w-full bg-white dark:bg-gray-800/50 border border-gray-300 dark:border-gray-700 rounded-lg pl-8 pr-3 py-1.5 text-[11px] text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:border-orange-500 outline-none transition-colors duration-200 shadow-sm"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>

                        {/* Columns (for Agents) */}
                        {activeTab === 'agents' && (
                            <div className="relative" ref={dropdownRef} data-col-menu>
                                <button
                                    onClick={() => setShowColumnSettings(!showColumnSettings)}
                                    className="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-100 transition-colors duration-200 flex items-center gap-2 shadow-sm"
                                >
                                    <Columns3 className="w-3.5 h-3.5" />
                                    <span className="text-[10px] font-bold uppercase tracking-wider">Columns</span>
                                </button>

                                {/* Dropdown */}
                                {showColumnSettings && (
                                    <div className="absolute top-full mt-2 right-0 w-52 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl z-[110] p-1.5 max-h-[450px] overflow-y-auto transition-colors duration-200">
                                        <div className="px-3 py-1.5 text-[9px] font-bold text-gray-700 dark:text-gray-100 uppercase border-b border-gray-200 dark:border-gray-800 mb-1 flex items-center justify-between transition-colors duration-200">
                                            <span>Toggle Columns</span>
                                            <button
                                                onClick={toggleAllColumns}
                                                className="text-[9px] text-orange-600 dark:text-orange-400 hover:text-orange-500 dark:hover:text-orange-300 transition-colors duration-200"
                                            >
                                                {Object.values(columnVisibility).every(Boolean)
                                                    ? 'Hide All'
                                                    : 'Show All'}
                                            </button>
                                        </div>
                                        {columns.map(({ key, label, icon: Icon, color }) => (
                                            <button
                                                key={key}
                                                onClick={() => toggleColumn(key)}
                                                className="w-full flex items-center justify-between px-3 py-2 text-[10px] font-bold uppercase text-gray-700 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors duration-200"
                                            >
                                                <div className="flex items-center gap-2.5">
                                                    <Icon className={`w-3 h-3 ${columnVisibility[key] ? color : 'text-gray-400 dark:text-gray-600'}`} />
                                                    {label}
                                                </div>
                                                <div className={`w-3 h-3 rounded border flex items-center justify-center transition-colors duration-200 ${columnVisibility[key] ? 'bg-orange-600 border-orange-600' : 'border-gray-300 dark:border-gray-700'}`}>
                                                    {columnVisibility[key] && <Check className="w-2.5 h-2.5 text-white" />}
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Columns (for Clusters) */}
                        {activeTab === 'clusters' && (
                            <div className="relative" ref={dropdownRef} data-col-menu>
                                <button
                                    onClick={() => setShowClusterColumnSettings(!showClusterColumnSettings)}
                                    className="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-100 transition-colors duration-200 flex items-center gap-2 shadow-sm"
                                >
                                    <Columns3 className="w-3.5 h-3.5" />
                                    <span className="text-[10px] font-bold uppercase tracking-wider">Columns</span>
                                </button>

                                {/* Dropdown */}
                                {showClusterColumnSettings && (
                                    <div className="absolute top-full mt-2 right-0 w-52 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl z-[110] p-1.5 max-h-[450px] overflow-y-auto transition-colors duration-200">
                                        <div className="px-3 py-1.5 text-[9px] font-bold text-gray-700 dark:text-gray-100 uppercase border-b border-gray-200 dark:border-gray-800 mb-1 flex items-center justify-between transition-colors duration-200">
                                            <span>Toggle Columns</span>
                                            <button
                                                onClick={toggleAllClusterColumns}
                                                className="text-[9px] text-orange-600 dark:text-orange-400 hover:text-orange-500 dark:hover:text-orange-300 transition-colors duration-200"
                                            >
                                                {Object.values(clusterVisibleColumns).every(Boolean)
                                                    ? 'Hide All'
                                                    : 'Show All'}
                                            </button>
                                        </div>
                                        {clusterColumnOptions.map((option) => (
                                            <button
                                                key={option.key}
                                                onClick={() => handleClusterColumnToggle(option.key)}
                                                className="w-full flex items-center justify-between px-3 py-2 text-[10px] font-bold uppercase text-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors duration-200"
                                            >
                                                <div className="flex items-center gap-2.5">
                                                    {clusterVisibleColumns[option.key] ? (
                                                        <Eye className="w-3 h-3 text-orange-500" />
                                                    ) : (
                                                        <EyeOff className="w-3 h-3 text-gray-400 dark:text-gray-600" />
                                                    )}
                                                    {option.label}
                                                </div>
                                                <div className={`w-3 h-3 rounded border flex items-center justify-center transition-colors duration-200 ${clusterVisibleColumns[option.key] ? 'bg-orange-600 border-orange-600' : 'border-gray-300 dark:border-gray-700'}`}>
                                                    {clusterVisibleColumns[option.key] && <Check className="w-2.5 h-2.5 text-white" />}
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Install (always show if permitted) */}
                        {level.name !== 'global' && canCreate && activeTab === 'agents' && (
                            <button
                                onClick={() => setShowInstallModal(true)}
                                className="flex items-center gap-1.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg px-4 py-1.5 text-[11px] text-gray-800 dark:text-white font-bold hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 shadow-sm"
                            >
                                <Download className="w-4 h-4 text-orange-500" />
                                Install
                            </button>
                        )}

                        {/* Export (only for Agents) */}
                        {activeTab === 'agents' && (
                            <button
                                onClick={() => setShowExportModal(true)}
                                className="flex items-center gap-1.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg px-4 py-1.5 text-[11px] text-gray-800 dark:text-white font-bold hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 shadow-sm"
                            >
                                <Download className="w-4 h-4 text-cyan-500" />
                                Export
                            </button>
                        )}

                        {/* Dropdown status/type (only for Agents) */}

                    </div>
                </div>

                {activeTab === 'agents' ? (
                    <>
                        {/* Table */}
                        <div className="bg-white dark:bg-gray-800/40 border border-gray-200 dark:border-gray-700 rounded-t-xl overflow-hidden shadow-sm dark:shadow-2xl">
                            <ScrollContainer
                                className="overflow-x-auto custom-scroll cursor-grab active:cursor-grabbing"
                                horizontal={true}
                                vertical={false}
                                hideScrollbars={false}
                            >
                                <table className="w-full text-left text-xs border-collapse">
                                    <thead className="bg-gray-50 dark:bg-gray-800/80 sticky top-0 z-10">
                                        <tr className="border-b border-gray-200 dark:border-gray-700/50">
                                            {columns.map(({ key, label }) =>
                                                columnVisibility[key] ? (
                                                    <th
                                                        key={key}
                                                        onClick={() => key !== 'actions' && key !== 'tags' && handleSort(key)}
                                                        className={`px-1 py-1.5 text-[10px] font-bold text-gray-700 dark:text-gray-100 uppercase tracking-widest select-none whitespace-nowrap ${key === 'actions' ? 'text-left sticky right-0 bg-gray-50 dark:bg-gray-800 z-10' : 'text-center cursor-pointer'
                                                            }`}
                                                    >
                                                        <div className={`flex items-center gap-1.5 justify-center`}>
                                                            {label}
                                                            {isSortable(key) && (
                                                                sortConfig?.key === key ? (
                                                                    sortConfig.direction === 'asc' ? (
                                                                        <ChevronUp size={12} />
                                                                    ) : (
                                                                        <ChevronDown size={12} />
                                                                    )
                                                                ) : (
                                                                    <ChevronDown size={12} />
                                                                )
                                                            )}
                                                        </div>
                                                    </th>
                                                ) : null
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-100 dark:divide-gray-700/30">
                                        {agentData.length === 0 && !loading ? (
                                            <tr>
                                                <td colSpan={Object.values(columnVisibility).filter(Boolean).length} className="py-16 text-center text-gray-500 dark:text-gray-100 font-bold uppercase tracking-widest italic">
                                                    No kubernetes found
                                                </td>
                                            </tr>
                                        ) : loading ? (
                                            <tr>
                                                <td colSpan={Object.values(columnVisibility).filter(Boolean).length} className="py-16 text-center text-gray-500 dark:text-gray-200 font-bold uppercase tracking-widest italic">
                                                    <div className="flex items-center justify-center gap-2">
                                                        <Loader2 className="w-4 h-4 animate-spin text-orange-500" />
                                                        Loading kubernetes
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            agentData.map((item: any, _index: any) => (
                                                <tr
                                                    key={item.id}
                                                    className="hover:bg-gray-50 dark:hover:bg-gray-800/60 transition-colors group border-b border-gray-100 dark:border-gray-700/30"
                                                >
                                                    {columnVisibility.hostname && (
                                                        <td className="px-1 py-0.5 font-mono text-center">
                                                            <div className="flex items-center justify-center gap-2 group/copy">
                                                                <button
                                                                    onClick={() => navigate(`/kubernetes/dashboard/${item.id}?client_id=${item.client_id}`)}
                                                                    className="text-blue-600 dark:text-blue-500 text-[11px] font-bold leading-none cursor-pointer hover:underline truncate max-w-[200px]"
                                                                    title={item.hostname || '-'}>
                                                                    {item.hostname || '-'}
                                                                </button>
                                                                {item.hostname && (
                                                                    <button
                                                                        onClick={() => copyToClipboard(item.hostname, `hostname-${item.id}`)}
                                                                        className="opacity-0 group-hover/copy:opacity-100 transition-opacity"
                                                                        title="Copy hostname"
                                                                    >
                                                                        <Copy className="w-2.5 h-2.5 text-gray-500 dark:text-gray-100 hover:text-gray-700 dark:hover:text-white" />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    )}

                                                    {columnVisibility.status && (
                                                        <td className="px-1 py-0.5 text-center">
                                                            <div
                                                                className="inline-flex items-center gap-2 px-2.5 py-0.5 rounded-full border border-gray-200 dark:border-gray-700/50 bg-gray-100 dark:bg-gray-900/50 relative group transition-colors duration-200"
                                                            >
                                                                {/* Status Dot */}
                                                                <div className={`w-1.5 h-1.5 rounded-full ${getStatusBg(item.status)}`}></div>

                                                                {/* Status Text */}
                                                                <span
                                                                    className={`text-[9px] font-bold uppercase tracking-wide ${getStatusColor(item.status)}`}
                                                                >
                                                                    {item.status}
                                                                </span>

                                                                {/* Tooltip (only if last_pinged_time exists) */}
                                                                {item.last_pinged_time && (
                                                                    <div className="absolute bottom-full left-0 mb-1 hidden group-hover:block bg-gray-900 text-white text-[9px] rounded px-2 py-1 whitespace-nowrap z-10 shadow-lg">
                                                                        <div>Last pinged</div>
                                                                        <div>{new Date(item.last_pinged_time).toLocaleString()}</div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    )}

                                                    {columnVisibility.version && (
                                                        <td className="px-1 py-0.5 text-center">
                                                            <span className="text-[10px] text-gray-800 dark:text-gray-100 font-medium">
                                                                {item?.version || '-'}
                                                            </span>
                                                        </td>
                                                    )}

                                                     {columnVisibility.tags && (
                                                         <td className="px-1 py-0.5 text-center">
                                                             <div className="flex items-center justify-center gap-1 flex-wrap max-w-[200px]">
                                                                 {(() => {
                                                                     let tagsArray: any[] = [];
                                                                     try {
                                                                         if (item.resolved_tags) {
                                                                             if (typeof item.resolved_tags === 'string') {
                                                                                 tagsArray = JSON.parse(item.resolved_tags);
                                                                             } else if (Array.isArray(item.resolved_tags)) {
                                                                                 tagsArray = item.resolved_tags;
                                                                             }
                                                                         } else if (item.tag_names) {
                                                                             tagsArray = item.tag_names.split(',').map((t: string) => t.trim()).filter(Boolean);
                                                                         } else if (item.tags) {
                                                                             if (typeof item.tags === 'string') {
                                                                                 tagsArray = JSON.parse(item.tags);
                                                                             } else if (Array.isArray(item.tags)) {
                                                                                 tagsArray = item.tags;
                                                                             }
                                                                         }
                                                                     } catch (e) {
                                                                         tagsArray = [];
                                                                     }
                                 
                                                                     if (tagsArray.length > 0) {
                                                                         return tagsArray.map((tag: any, idx: number) => {
                                                                             const name = typeof tag === 'object' && tag !== null ? tag.name : tag;
                                                                             return (
                                                                                 <span key={idx} className="bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 text-[9px] px-1.5 py-0.5 rounded border border-gray-200 dark:border-gray-600 transition-colors duration-200">
                                                                                     {name}
                                                                                 </span>
                                                                             );
                                                                         });
                                                                     }
                                                                     return '-';
                                                                 })()}
                                                             </div>
                                                         </td>
                                                     )}

                                                    {columnVisibility.client_name && (level.name === 'global') && (
                                                        <td className="px-1 py-0.5 text-center">
                                                            <span className="text-[10px] text-gray-800 dark:text-gray-100 font-medium">
                                                                {item?.client_name || '-'}
                                                            </span>
                                                        </td>
                                                    )}

                                                    {columnVisibility.created && (
                                                        <td className="px-1 py-0.5 text-center">
                                                            <span className="text-[10px] text-gray-800 dark:text-gray-100 font-medium">
                                                                {item?.created
                                                                    ? new Date(item.created).toLocaleString(undefined, {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                        year: "numeric",
                                                                        month: "short",
                                                                        day: "2-digit",
                                                                        hour12: true,
                                                                    })
                                                                    : "-"}
                                                            </span>
                                                        </td>
                                                    )}

                                                    {columnVisibility.actions && (canDelete || canEdit) && (
                                                        <td className="px-1 py-0.5 whitespace-nowrap text-center text-xs font-medium sticky right-0 z-10 bg-white dark:bg-gray-900 group-hover:bg-gray-50 dark:group-hover:bg-gray-800 transition-colors duration-200">
                                                            <div className="flex items-center justify-center space-x-2 relative">
                                                                <div className="relative">
                                                                    <button
                                                                        onClick={(e) => handleMenuOpen(e, item.id)} // ✅ Correct call
                                                                        className="p-1 rounded-full flex items-center transition-colors duration-200 text-orange-500 hover:text-orange-600 dark:text-orange-400 dark:hover:text-orange-300 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
                                                                    >
                                                                        <CircleEllipsis className="w-4 h-4" />
                                                                    </button>

                                                                    {openMenuId === item.id &&
                                                                        createPortal(
                                                                            <div
                                                                                ref={menuDropdownRef} // ✅ this enables outside click detection
                                                                                className="mt-2 w-40 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-[9999] py-1 transition-colors duration-200"
                                                                                style={{
                                                                                    top: dropdownPosition.top,
                                                                                    left: dropdownPosition.left,
                                                                                    position: "fixed",
                                                                                }}
                                                                            >
                                                                                <button
                                                                                    onClick={() => {
                                                                                        setSelectedAgentForConfig(item);
                                                                                        setShowConfigModal(true);
                                                                                        setOpenMenuId(null);
                                                                                    }}
                                                                                    disabled={item.agent_type === 'k8'}
                                                                                    className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 transition-colors duration-200 ${
                                                                                        item.agent_type === 'k8'
                                                                                            ? 'text-gray-400 dark:text-gray-600 cursor-not-allowed opacity-50'
                                                                                            : 'text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700'
                                                                                    }`}
                                                                                >
                                                                                    <Settings className="w-4 h-4 text-orange-500 dark:text-orange-400" />
                                                                                    K8 Config
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        setTagAgentId(item.id);
                                                                                        setTagAgentName(item.hostname || item.name || 'Agent');
                                                                                        let tagsArray: string[] = [];
                                                                                        try {
                                                                                            if (typeof item.tags === 'string') {
                                                                                                tagsArray = JSON.parse(item.tags);
                                                                                            } else if (Array.isArray(item.tags)) {
                                                                                                tagsArray = item.tags;
                                                                                            }
                                                                                        } catch (e) {
                                                                                            tagsArray = [];
                                                                                        }
                                                                                        setTagAgentTags(tagsArray);
                                                                                        setTagModalOpen(true);
                                                                                        setOpenMenuId(null);
                                                                                    }}
                                                                                    className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 border-t border-gray-100 dark:border-gray-800 transition-colors duration-200"
                                                                                >
                                                                                    <Tag className="w-4 h-4 text-orange-500 dark:text-orange-400" />
                                                                                    Tags
                                                                                </button>
                                                                            </div>,
                                                                            document.body
                                                                        )}

                                                                </div>
                                                            </div>
                                                        </td>
                                                    )}

                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </ScrollContainer>
                        </div>


                        {/* Table Footer */}
                        <div className="bg-gray-50 dark:bg-gray-800/50 border rounded-b-xl border-gray-200 dark:border-gray-700 px-2 py-1 flex items-center justify-between">
                            <div className="flex items-center gap-4">
                                <ItemsPerPageDropdown
                                    value={itemsPerPage}
                                    onChange={(val: any) => handleItemsPerPageChange(val)}
                                />
                                <span className="text-[10px] text-gray-600 dark:text-gray-100 font-bold uppercase tracking-widest">
                                    <span className="text-gray-900 dark:text-gray-200">{startIndex + 1}</span> - <span className="text-gray-900 dark:text-gray-200">{Math.min(endIndex, totalItems)}</span> OF {totalItems}
                                </span>
                            </div>
                            <div className="flex items-center gap-1">
                                <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="p-1.5 text-gray-600 dark:text-gray-100 hover:text-gray-900 dark:hover:text-white disabled:opacity-30 transition-colors"><ChevronsLeft className="w-4 h-4" /></button>
                                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="p-1.5 text-gray-600 dark:text-gray-100 hover:text-gray-900 dark:hover:text-white disabled:opacity-30 transition-colors"><ChevronLeft className="w-4 h-4" /></button>
                                <div className="px-3 py-1 bg-orange-600 rounded-lg text-white text-[11px] font-bold mx-1.5 shadow-lg shadow-orange-900/20">{currentPage}</div>
                                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-1.5 text-gray-600 dark:text-gray-100 hover:text-gray-900 dark:hover:text-white disabled:opacity-30 transition-colors"><ChevronRight className="w-4 h-4" /></button>
                                <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="p-1.5 text-gray-600 dark:text-gray-100 hover:text-gray-900 dark:hover:text-white disabled:opacity-30 transition-colors"><ChevronsRight className="w-4 h-4" /></button>
                            </div>
                        </div>
                    </>
                ) : (
                    <KubernetesClustersTable
                        clientId={level?.id}
                        searchTerm={debouncedSearch}
                        refreshTrigger={clusterRefreshTrigger}
                        onLoadingChange={setClustersLoading}
                        visibleColumns={clusterVisibleColumns}
                    />
                )}
            </div>

            <Modal open={showInstallModal} onClose={handleCloseInstallModal}>
                <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
        w-[90%] sm:w-[540px] max-w-xl bg-white dark:bg-gray-900/95 backdrop-blur-xl 
        border border-gray-200 dark:border-orange-500/20 shadow-2xl p-5 rounded-2xl text-gray-900 dark:text-white
        relative overflow-hidden transition-colors duration-200">

                    {/* Subtle top border */}
                    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-orange-500/40 to-transparent"></div>

                    {/* Header */}
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-2">
                            <div className="bg-orange-500/10 dark:bg-orange-500/20 p-1.5 rounded-lg border border-orange-500/20 dark:border-orange-500/30">
                                <Download className="w-5 h-5 text-orange-500 dark:text-orange-400" />
                            </div>
                            <div>
                                <h2 className="text-lg font-bold text-gray-900 dark:text-white leading-none">Install Kubernetes Agent</h2>
                                <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-1">Deploy the scanner agent into your Kubernetes cluster</p>
                            </div>
                        </div>
                        <button
                            onClick={handleCloseInstallModal}
                            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-white transition-colors bg-gray-100 hover:bg-gray-200 dark:bg-gray-800/50 dark:hover:bg-gray-800 p-1.5 rounded-lg border border-gray-200 dark:border-gray-700/50"
                        >
                            <X className="w-4 h-4" />
                        </button>
                    </div>

                    {/* Tabs / Method Selector */}
                    <div className="flex bg-gray-100 dark:bg-gray-800/80 p-0.5 rounded-lg border border-gray-200 dark:border-gray-700/50 mb-4 w-fit transition-colors duration-200">
                        <button
                            type="button"
                            onClick={() => setInstallMethod('manual')}
                            className={`px-3 py-1 text-xs font-bold rounded-md transition-all ${installMethod === 'manual'
                                ? 'bg-orange-600 text-white shadow-md'
                                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                                }`}
                        >
                            Manual
                        </button>
                        <button
                            type="button"
                            onClick={() => setInstallMethod('existing')}
                            className={`px-3 py-1 text-xs font-bold rounded-md transition-all ${installMethod === 'existing'
                                ? 'bg-orange-600 text-white shadow-md'
                                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                                }`}
                        >
                            Add to Existing Agent
                        </button>
                    </div>

                    {installMethod === 'manual' ? (
                        !generatedYaml ? (
                            /* SCREEN 1: FORM */
                            <form onSubmit={handleGenerateYaml} className="space-y-4">
                                <div className="space-y-1.5">
                                    <label className="text-xs font-semibold uppercase tracking-wider text-orange-600 dark:text-orange-400 flex items-center gap-1.5">
                                        <Server className="w-3.5 h-3.5" />
                                        Cluster Name
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="e.g. production-cluster"
                                        value={clusterName}
                                        onChange={(e) => setClusterName(e.target.value)}
                                        className="w-full bg-gray-50 dark:bg-gray-800/40 border border-gray-300 dark:border-gray-700/80 rounded-lg px-3 py-2 text-xs text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:border-orange-500/50 outline-none transition-all"
                                        required
                                        disabled={isGeneratingYaml}
                                    />
                                </div>

                                <div className="space-y-1.5">
                                    <label className="text-xs font-semibold uppercase tracking-wider text-orange-600 dark:text-orange-400 flex items-center gap-1.5">
                                        <Columns3 className="w-3.5 h-3.5" />
                                        Cluster Tags
                                    </label>
                                    <div className="flex flex-wrap gap-1.5 p-2 bg-gray-50 dark:bg-gray-800/40 border border-gray-300 dark:border-gray-700/80 rounded-lg min-h-[44px] items-center focus-within:border-orange-500/50 transition-all">
                                        {clusterTags.map((tag, idx) => (
                                            <span key={idx} className="flex items-center gap-1 bg-orange-100 dark:bg-orange-500/10 text-orange-700 dark:text-orange-300 text-[10px] font-bold px-2 py-0.5 rounded-full border border-orange-200 dark:border-orange-500/20 transition-all hover:bg-orange-200 dark:hover:bg-orange-500/20">
                                                {tag}
                                                <button
                                                    type="button"
                                                    onClick={() => setClusterTags(clusterTags.filter((_, i) => i !== idx))}
                                                    className="text-orange-600 dark:text-orange-400 hover:text-orange-800 dark:hover:text-orange-200 transition-colors focus:outline-none"
                                                    disabled={isGeneratingYaml}
                                                >
                                                    <X className="w-2.5 h-2.5" />
                                                </button>
                                            </span>
                                        ))}
                                        <input
                                            type="text"
                                            placeholder={clusterTags.length === 0 ? "Add tags (press Enter or comma to add)" : "Add more tags..."}
                                            value={currentTagInput}
                                            onChange={(e) => setCurrentTagInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ',') {
                                                    e.preventDefault();
                                                    const tag = currentTagInput.trim().replace(/,/g, '');
                                                    if (tag && !clusterTags.includes(tag)) {
                                                        setClusterTags([...clusterTags, tag]);
                                                    }
                                                    setCurrentTagInput("");
                                                }
                                            }}
                                            className="flex-1 min-w-[120px] bg-transparent border-none outline-none text-xs text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 py-0.5"
                                            disabled={isGeneratingYaml}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const tag = currentTagInput.trim().replace(/,/g, '');
                                                if (tag && !clusterTags.includes(tag)) {
                                                    setClusterTags([...clusterTags, tag]);
                                                }
                                                setCurrentTagInput("");
                                            }}
                                            className="text-[10px] font-bold uppercase tracking-wider text-orange-600 dark:text-orange-400 hover:text-orange-700 dark:hover:text-orange-300 px-2 py-1 transition-all rounded hover:bg-orange-50 dark:hover:bg-orange-500/10"
                                            disabled={isGeneratingYaml}
                                        >
                                            + Add
                                        </button>
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="flex justify-end gap-3 pt-2 border-t border-gray-200 dark:border-gray-800">
                                    <button
                                        type="button"
                                        onClick={handleCloseInstallModal}
                                        className="px-4 py-2 border border-gray-300 dark:border-gray-700/80 text-gray-700 dark:text-gray-300 rounded-lg text-xs font-semibold hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white transition-all"
                                        disabled={isGeneratingYaml}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="flex items-center gap-1.5 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white text-xs font-bold px-4 py-2 rounded-lg transition-all shadow-lg shadow-orange-950/20 disabled:opacity-55 disabled:cursor-not-allowed"
                                        disabled={isGeneratingYaml}
                                    >
                                        {isGeneratingYaml ? (
                                            <>
                                                <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                                Generating YAML...
                                            </>
                                        ) : (
                                            <>
                                                <Download className="w-3.5 h-3.5" />
                                                Generate YAML
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        ) : (
                            /* SCREEN 2: YAML RESULT DISPLAY */
                            <div className="space-y-4">
                                <div className="flex items-center justify-between">
                                    <span className="text-xs font-semibold uppercase tracking-wider text-green-600 dark:text-green-400 flex items-center gap-1.5">
                                        <Check className="w-3.5 h-3.5 text-green-600 dark:text-green-400" />
                                        YAML Configuration Generated
                                    </span>
                                    <div className="flex items-center gap-2">
                                        <button
                                            type="button"
                                            onClick={copyYamlToClipboard}
                                            className="flex items-center gap-1.5 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 dark:hover:bg-gray-700 text-[10px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-lg transition-all text-gray-800 dark:text-white"
                                        >
                                            {yamlCopied ? <Check className="w-3.5 h-3.5 text-green-500 dark:text-green-400 animate-bounce" /> : <Copy className="w-3.5 h-3.5 text-blue-500 dark:text-blue-400" />}
                                            {yamlCopied ? "Copied" : "Copy"}
                                        </button>
                                        <button
                                            type="button"
                                            onClick={downloadYamlFile}
                                            className="flex items-center gap-1.5 bg-orange-600 hover:bg-orange-700 text-[10px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-lg transition-all text-white shadow-lg shadow-orange-900/20"
                                        >
                                            <Download className="w-3.5 h-3.5" />
                                            Download
                                        </button>
                                    </div>
                                </div>

                                <div className="relative">
                                    <pre className="bg-gray-50 dark:bg-gray-950 border border-gray-200 dark:border-gray-800/80 rounded-xl p-3 overflow-y-auto max-h-[280px] text-[10px] font-mono text-gray-800 dark:text-gray-300 custom-scroll whitespace-pre-wrap break-all leading-relaxed transition-colors duration-200">
                                        {generatedYaml}
                                    </pre>
                                </div>

                                <div className="text-[11px] text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-800/30 p-3 rounded-xl border border-gray-200 dark:border-gray-800/80 flex items-start gap-2.5 transition-colors duration-200">
                                    <div className="bg-orange-500/10 p-1 rounded border border-orange-500/20 text-orange-600 dark:text-orange-400 font-bold text-[9px] uppercase tracking-wider mt-0.5">
                                        Apply
                                    </div>
                                    <div className="leading-relaxed">
                                        Apply the generated configuration:
                                        <div className="mt-1.5 bg-white dark:bg-gray-950 px-2.5 py-1.5 rounded-lg text-orange-600 dark:text-orange-300 font-mono border border-gray-200 dark:border-gray-800/60 select-all flex items-center justify-between">
                                            <span>kubectl apply -f {clusterName.replace(/\s+/g, '_') || 'k8s'}-cluster.yaml</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="flex justify-end pt-2 border-t border-gray-200 dark:border-gray-800">
                                    <button
                                        type="button"
                                        onClick={handleCloseInstallModal}
                                        className="px-5 py-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 border border-gray-300 dark:border-gray-700/80 text-gray-800 dark:text-white rounded-lg text-xs font-semibold dark:hover:bg-gray-700 dark:hover:text-white transition-all"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        )
                    ) : (
                        /* EXISTING AGENT WORKFLOW */
                        <div className="space-y-4">
                            <div className="space-y-1.5">
                                <label className="text-xs font-semibold uppercase tracking-wider text-orange-600 dark:text-orange-400 flex items-center gap-1.5">
                                    <Server className="w-3.5 h-3.5" />
                                    Select Agent
                                </label>
                                <SingleSelectApiDropdown
                                    apiEndpoint="/agents"
                                    displayProperty="hostname"
                                    secondaryDisplayProperty="ip_address"
                                    searchFields={['hostname', 'ip_address']}
                                    value={selectedExistingAgent}
                                    onChange={handleSelectExistingAgent}
                                    additionalQueries={{
                                        platform: 'linux',
                                        ...(level?.id ? { client_id: level.id } : {})
                                    }}
                                    placeholder="Select a Linux agent"
                                    searchInputPlaceholder="Search by hostname or IP"
                                    className="w-full"
                                    buttonClassName="h-10"
                                />
                            </div>

                            {selectedExistingAgent && (
                                <div className="p-3 bg-gray-50 dark:bg-gray-800/40 border border-gray-200 dark:border-gray-700/80 rounded-xl space-y-3 transition-colors duration-200">
                                    <div className="flex items-center justify-between">
                                        <span className="text-xs font-semibold text-gray-700 dark:text-gray-300">
                                            Kubernetes Support:
                                        </span>
                                        {isK8sEnabled ? (
                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-green-500/10 text-green-600 dark:text-green-400 border border-green-500/20 text-[10px] font-bold uppercase">
                                                <Check className="w-3.5 h-3.5" /> Enabled
                                            </span>
                                        ) : (
                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-gray-200 dark:bg-gray-500/10 text-gray-600 dark:text-gray-400 border border-gray-300 dark:border-gray-500/20 text-[10px] font-bold uppercase">
                                                Disabled
                                            </span>
                                        )}
                                    </div>

                                    {!isK8sEnabled && (
                                        <div className="flex justify-end pt-1">
                                            <button
                                                type="button"
                                                onClick={handleEnableK8s}
                                                disabled={isEnablingK8s}
                                                className="flex items-center gap-1.5 bg-orange-600 hover:bg-orange-700 disabled:bg-orange-600/50 text-white text-xs font-bold px-4 py-2 rounded-lg transition-all shadow-lg shadow-orange-950/20 disabled:cursor-not-allowed"
                                            >
                                                {isEnablingK8s ? (
                                                    <>
                                                        <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                                        Enabling...
                                                    </>
                                                ) : (
                                                    "Enable Kubernetes"
                                                )}
                                            </button>
                                        </div>
                                    )}

                                    <div className="space-y-1.5 pt-2 border-t border-gray-200 dark:border-gray-800">
                                        <label className={`text-xs font-semibold uppercase tracking-wider flex items-center gap-1.5 ${isK8sEnabled ? 'text-orange-600 dark:text-orange-400' : 'text-gray-400 dark:text-gray-500'}`}>
                                            Kubeconfig Path
                                        </label>
                                        <div className="flex gap-2">
                                            <input
                                                type="text"
                                                placeholder={isK8sEnabled ? "e.g. /home/user/.kube/config" : "Enable Kubernetes to specify path"}
                                                value={kubeconfigPath}
                                                onChange={(e) => setKubeconfigPath(e.target.value)}
                                                disabled={!isK8sEnabled}
                                                className="flex-1 bg-white dark:bg-gray-800/40 border border-gray-300 dark:border-gray-700/80 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg px-3 py-2 text-xs text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:border-orange-500/50 outline-none transition-all"
                                            />
                                            <button
                                                type="button"
                                                onClick={handleAddKubeconfigPath}
                                                disabled={!isK8sEnabled || !kubeconfigPath.trim()}
                                                className="bg-orange-600 hover:bg-orange-700 disabled:bg-gray-200 dark:disabled:bg-gray-800 disabled:text-gray-400 dark:disabled:text-gray-500 disabled:border-gray-300 dark:disabled:border-gray-700 disabled:cursor-not-allowed text-white text-xs font-bold px-4 py-2 rounded-lg transition-all border border-transparent shadow-lg shadow-orange-950/20"
                                            >
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Footer actions for Existing Agent */}
                            <div className="flex justify-end pt-2 border-t border-gray-200 dark:border-gray-800">
                                <button
                                    type="button"
                                    onClick={handleCloseInstallModal}
                                    className="px-4 py-2 border border-gray-300 dark:border-gray-700/80 text-gray-700 dark:text-gray-300 rounded-lg text-xs font-semibold hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white transition-all"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </Modal>

            <AgentExportModal
                isOpen={showExportModal}
                onClose={() => setShowExportModal(false)}
                templateName="agents"
                clientId={level?.id}
            />

            <AgentConfigModal
                open={showConfigModal}
                onClose={() => {
                    setShowConfigModal(false);
                    setSelectedAgentForConfig(null);
                }}
                agent={selectedAgentForConfig}
            />

            <AgentTagModal
                open={tagModalOpen}
                onClose={() => {
                    setTagModalOpen(false);
                    setTagAgentId(null);
                    setTagAgentName('');
                    setTagAgentTags([]);
                }}
                agentId={tagAgentId}
                agentName={tagAgentName}
                agentTags={tagAgentTags}
                onSuccess={fetchData}
            />

        </div>
    );
};

export default KubernetesTable;
